/**
 * @desc 财务画像-财务风险分析-风险模板
 * @author caoyx
 */

import styles from './template.scss';
import React from 'react';
import cns from 'classnames';
import { Table } from 'antd';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import { PAGE_SIZE } from '../../../../constants/common';
import {fieldAnomaly} from '../../../../utils/formatter';
import {removeCommonIndex, avgScatterOption} from '../../common/commons';

export default function Template({ className, data = {}, ...other }) {
    const {
        abnormalIndex,
        abnormalIndexDescription,
        financeRiskAbnormalDetailDtoList = [],
        financeRiskCurrentYearStaticsVO = {},
        financeRiskLatestYearStaticsVOList = []
    } = data;

    const riskTemplateColumns = [{
        title: '时间',
        dataIndex: 'abnormalYear',
        width: 50,
        render: fieldAnomaly
    }, {
        title: fieldAnomaly(abnormalIndex),
        dataIndex: 'abnormalIndexValue',
        render: removeCommonIndex
    }, {
        title: '行业平均数',
        dataIndex: 'abnormalAverage',
        width: 210,
        render: removeCommonIndex
    }, {
        title: '正常范围',
        dataIndex: 'abnormalRange',
        width: 160,
        render: fieldAnomaly
    }];

    let scatterOption = avgScatterOption(financeRiskCurrentYearStaticsVO);

    const lineOption = {
        color: ['#3370C8', '#F99248'],
        grid: {
            top: 35
        },
        legend: {
            type: 'scroll',
            left: 20
        },
        category: [],
        lineData: [{ name: `${abnormalIndex}`, data: [] }, { name: `${abnormalIndex}行业平均数`, data: [] }]
    };
    
    financeRiskLatestYearStaticsVOList.forEach(item => {
        lineOption.category.push(item.year);
        lineOption.lineData[0].data.push(item.current);
        lineOption.lineData[1].data.push(item.average);
    });
    lineOption.category.reverse();
    lineOption.lineData[0].data.reverse();
    lineOption.lineData[1].data.reverse();

    return (
        <div className={cns('clearfix', styles.indexWrap, className)} {...other}>
            <div>
                <div className={styles.descBox}>
                    <div className={styles.title}>异常指标：{abnormalIndex}</div>
                    <div>{fieldAnomaly(abnormalIndexDescription)}</div>
                </div>

                <Table
                    bordered
                    rowKey="abnormalYear"
                    dataSource={financeRiskAbnormalDetailDtoList}
                    columns={riskTemplateColumns}
                    pagination={financeRiskAbnormalDetailDtoList.length > PAGE_SIZE}
                />
            </div>

            <div className={styles.chartsLayout}>
                <div className={styles.chartBox}>
                    <p className="wrap-title">行业内所有公司的{abnormalIndex}</p>
                    <BBDLineBar option={scatterOption} />
                </div>
                <div className={styles.chartBox}>
                    <p className="wrap-title">数据历史变化情况</p>
                    <BBDLineBar option={lineOption} />
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/Template.jsx